/* eslint-disable import/no-named-as-default */
import React, { useEffect, useState, useContext } from 'react';

import ResponsiveHeader from '../responsive-header/ResponsiveHeader';

import { SkipLinks } from '../link-list/LinkList';
import { skipLinks } from '../links';
import authenticateUser from '../../../client/authenticate-user';
import getNotifications from '../notification-banner/get-notifications';
import NotificationBanner from '../notification-banner/NotificationBanner';
import Navigation from '../navigation/Navigation';
import Chat from '../chat/Chat';
import useShowNotification from './useShowNotification';
import styles from './header-wrapper.scss';
import { UserContext } from '../../scaffold/UserContext';
import getUserProfile from '../../../client/getUserProfile';
import isMonetateGroup from '../../utils/monetate/isMonetateGroup';

const Header = ({ experiences, features }) => {
  const { topNotification, bottomNotification } = getNotifications(experiences);

  const [showTopNotification, setTopNotification] = useShowNotification(
    topNotification
  );
  const [showBottomNotification, setBottomNotification] = useShowNotification(
    bottomNotification
  );

  const [mobileNavShown, setMobileNavShown] = useState(false);

  const { updateUserState } = useContext(UserContext);
  const [componentMounted, updateComponentMounted] = useState(false);

  useEffect(() => {
    if (features.authenticationEnabled && !componentMounted) {
      authenticateUser(updateUserState);
    } else if (!features.authenticationEnabled && !componentMounted) {
      const userProfile = getUserProfile();
      updateUserState(userProfile);
    }
    updateComponentMounted(true);
  }, [componentMounted]);

  const doSeparateNavigation = isMonetateGroup(
    features,
    'separate-nav-components'
  );

  return (
    <header className={styles.siteWide}>
      <Chat />
      <div className={styles.headerContainer}>
        <SkipLinks links={skipLinks} />
        <ResponsiveHeader
          updateMobileNavState={setMobileNavShown}
          topNotification={
            showTopNotification && (
              <NotificationBanner
                closeHandler={setTopNotification}
                {...(topNotification && topNotification.parameters)}
              />
            )
          }
          bottomNotification={
            showBottomNotification && (
              <NotificationBanner
                className={styles.mobileNotification}
                closeHandler={setBottomNotification}
                {...(bottomNotification && bottomNotification.parameters)}
              />
            )
          }
        />
      </div>
      <Navigation
        mobileNavShown={mobileNavShown}
        doSeparateNavigation={doSeparateNavigation}
      />
      {showBottomNotification && (
        <NotificationBanner
          className={styles.desktopNotification}
          closeHandler={setBottomNotification}
          {...(bottomNotification && bottomNotification.parameters)}
        />
      )}
    </header>
  );
};

export default Header;
